/**
 * Login Page
 * Log in with tenant + token (shared household account). The tenant field
 * is pre-filled from the last_tenant cookie for returning users.
 */

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { useAuth, getLastTenant } from '../context/AuthContext';

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [tenant, setTenant] = useState('');
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Pre-fill the tenant for returning users
  useEffect(() => {
    setTenant(getLastTenant());
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      await login(tenant, token);
      const from = location.state?.from || '/dashboard';
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
      setSubmitting(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
      <Card style={{ width: '420px' }}>
        <Card.Header className="bg-dark text-white">
          <h5 className="mb-0"><i className="bi bi-house-lock me-2"></i>Log In</h5>
        </Card.Header>
        <Card.Body>
          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Tenant</Form.Label>
              <Form.Control
                type="text"
                value={tenant}
                onChange={(e) => setTenant(e.target.value)}
                placeholder="e.g. 1463 LAVENDER LP"
                autoFocus
                required
              />
              <Form.Text className="text-muted">
                Your building's tenant name — shared by the whole household
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Token</Form.Label>
              <Form.Control
                type="password"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder="Your household token"
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100" disabled={submitting}>
              {submitting ? 'Logging in...' : 'Log In'}
            </Button>
          </Form>

          <hr />

          <div className="text-center">
            <small>
              New here? <Link to="/signup">Create an account</Link>
            </small>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default LoginPage;
